import content from '../generated/content.json';

export const profile = content.profile;
